import {
	connect
} from 'react-redux'
import SimpleDataTable from '../components/common/SimpleDataTable.jsx';
import {
	findOrderAppCheck,
	changeShowAppCheckDiv,
	deleteOrderAppCheck
} from '../actions';

const mapStateToProps = (state) => ({
	data: state.getIn(['fitting1Reducer', 'orderAppCheckList']),
	fields: {
		checkId: '檢查碼',
		orderId: '訂單編號',
		fittingName: '套量訂單顯示',
		startDate: '開始時間',
		endDate: '結束時間',
	},
	keys: ['checkId', 'orderId'],
	showDelete: true,
	showEdit: true
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: () => {
	},
	deleteItem: (pk) => {
		dispatch(deleteOrderAppCheck(pk));
		dispatch(changeShowAppCheckDiv('hidden'));
	},
	editItem: (pk) => {
		dispatch(findOrderAppCheck(pk));
		dispatch(changeShowAppCheckDiv('edit'));
	},
})

const OrderAppCheckListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(SimpleDataTable)

export default OrderAppCheckListContainer;


// WEBPACK FOOTER //
// ./src/containers/OrderAppCheckListContainer.jsx